import { tokenFromPath } from "./trip.ts";

/**
 * One build serves ichegoubr.com (landing, the menu's pages, privacidade, termos) and v.ichegoubr.com (shared trip
 * links, `/v/{token}` and `/{token}`). Named pages win over tokens: "privacidade" would pass as one.
 */
export type Route =
  | { page: "landing" | "driver" | "rider" | "about" | "news" | "help" | "register" | "unsubscribe" | "privacy" | "terms" }
  | { page: "trip"; token: string | null };

const PAGES: Record<string, Route> = {
  "": { page: "landing" },
  motorista: { page: "driver" },
  passageiro: { page: "rider" },
  "sobre-nos": { page: "about" },
  noticias: { page: "news" },
  ajuda: { page: "help" },
  "motorista/cadastro": { page: "register" },
  "motorista/cadastro/parar": { page: "unsubscribe" },
  privacidade: { page: "privacy" },
  termos: { page: "terms" },
};

export function routeFor(pathname: string): Route {
  const path = pathname.replace(/^\/+|\/+$/g, "");
  const named = PAGES[path.toLowerCase()];
  if (named) return named;
  return { page: "trip", token: tokenFromPath(pathname) };
}

/** Titles per page; the trip page keeps its own. Shared trip links stay out of search engines. */
export const pageMeta: Record<Route["page"], { title: string; indexable: boolean }> = {
  landing: { title: "ichegou · corridas e envios com preço fechado", indexable: true },
  driver: { title: "Seja motorista · ichegou", indexable: true },
  rider: { title: "Corridas e envios para passageiros · ichegou", indexable: true },
  about: { title: "Sobre nós · ichegou", indexable: true },
  news: { title: "Notícias · ichegou", indexable: true },
  help: { title: "Ajuda · ichegou", indexable: true },
  register: { title: "Cadastro de motorista · ichegou", indexable: true },
  unsubscribe: { title: "Parar lembretes · ichegou", indexable: false },
  privacy: { title: "Política de Privacidade · ichegou", indexable: true },
  terms: { title: "Termos de Uso · ichegou", indexable: true },
  trip: { title: "ichegou · viagem compartilhada", indexable: false },
};
